import { createVNode as n, mergeProps as a } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MinusCircleOutlinedStandard.js";
import d from "../components/PfIcon.js";
const r = (t, e) => {
  const i = {
    ...t,
    ...e.attrs
  };
  return n(d, a(i, {
    icon: o
  }), null);
};
r.displayName = "MinusCircleOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
